import Comments from '../components/comment'
import Loading from 'vue-loading-overlay'

export default {
  Comments,
  Loading
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/details/resources/components.js